// src/constants/validationRules.js

export const isValidUSPhone = (value) => {
  const digits = (value || '').replace(/\D/g, '');   
  const ten = digits.replace(/^1/, '');              
  return ten.length === 10;                         
};

export const PATIENT_VALIDATION = {
    first_name: {
      required: true,
      message: 'First name is required'
    },
    last_name: {
      required: true,
      message: 'Last name is required'
    },
    email: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Please enter a valid email address'
    },
    phone_number: {
      required: true,
      validator: (v) => isValidUSPhone(v),
      message: 'Phone number must be 11 digits (with optional + prefix)'
    },
    birthdate: {
      required: true,
      custom: (value) => {
        const birthDate = new Date(value);
        const today = new Date();
        if (birthDate >= today) {
          return 'Birthdate must be in the past';
        }
        return null;
      }
    },
    gender: {
      required: true,
      message: 'Gender is required'
    }
  };
  
  export const ENROLLMENT_VALIDATION = {
    patient_id: {
      required: true,
      message: 'Patient is required'
    },
    start_date: {
      required: true,
      message: 'Start date is required'
    },
    end_date: {
      required: true,
      message: 'End date is required',
      custom: (value, formData) => {
        if (!value) return null;
        const endDate = new Date(value + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
  
        if (endDate < today) {
          return 'End date cannot be in the past';
        }
        if (formData.start_date) {
          const startDate = new Date(formData.start_date + 'T00:00:00');
          startDate.setHours(0, 0, 0, 0);
          if (endDate <= startDate) {
            return 'End date must be after start date';
          }
        }
        return null;
      }
    },
    call_rules: {
      custom: (value) => {
        if (!Array.isArray(value)) return null;
        for (const rule of value) {
          if (rule.frequency === 'once' && !rule.date) {
            return 'One-time calls require a date';
          }
          if (rule.frequency === 'weekly' && (!rule.days || rule.days.length === 0)) {
            return 'Weekly calls require at least one day selected';
          }
          if (rule.frequency === 'monthly' && (!rule.days_of_month || rule.days_of_month.length === 0)) {
            return 'Monthly calls require at least one day of the month selected';
          }
        }
        return null;
      }
    },
    device_id: {
      custom: (value, formData, context) => {
        if (!context?.isOnboardingProgram) return null;
        if (!value) return 'Device ID is required';
        if (!/^[A-Za-z0-9]{4}$/.test(value)) return 'Device ID must be exactly 4 alphanumeric characters';
        return null;
      }
    }
  };
  
  export const GENDER_OPTIONS = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Other', label: 'Other' }
  ];